var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWorkspace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 5H8C5.79086 5 4 6.79086 4 9V21C4 23.2091 5.79086 25 8 25H22C24.2091 25 26 23.2091 26 21V13V11V9C26 6.79086 24.2091 5 22 5ZM24 11V9C24 7.89543 23.1046 7 22 7H8C6.89543 7 6 7.89543 6 9V11H24ZM6 13V21C6 22.1046 6.89543 23 8 23H10.5V13H6ZM12.5 23H22C23.1046 23 24 22.1046 24 21V13H12.5V23Z",
    fill: "#97B7EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkspace);
export default __webpack_public_path__ + "static/media/workspace.415abcee16326425b81dc62be51bf75d.svg";
export { ForwardRef as ReactComponent };